import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginComponent } from './auth/login/login.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';

import { ApiManagerComponent } from './admin/api-manager/api-manager.component';
import { ApiMappingComponent } from './admin/api-mapping/api-mapping.component';
import { ApiResponseMappingListComponent } from './admin/api-response-mapping-list/api-response-mapping-list.component';
import { ApiResponseMappingComponent } from './admin/api-response-mapping/api-response-mapping.component';
import { AttributeComponent } from './admin/attribute/attribute.component';

import { CategoryComponent } from './admin/category/category.component';
import { EntityComponent } from './admin/entity/entity.component';
import { SubcategoryComponent } from './admin/subcategory/subcategory.component';
import { UserComponent } from './admin/user/user.component';
import { AnalyticsComponent } from './analytics/analytics.component';	
import { ApiGroupComponent } from './admin/api-group/api-group.component';	
import { ApigrouplistComponent } from './admin/apigrouplist/apigrouplist.component';			
import { RepositoryComponent } from './admin/repository/repository.component';  
import { AttributeListComponent } from './admin/attribute-list/attribute-list.component';
												 

const routes: Routes = [
  { path: '',  redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'pagenotfound', component: PagenotfoundComponent },
  { path: 'apiManager', component: ApiManagerComponent },
  { path: 'apiMapping', component: ApiMappingComponent },
  { path: 'responseMapping', component: ApiResponseMappingListComponent },
  { path: 'responseMappingForm', component: ApiResponseMappingComponent },
  { path: 'attribute', component: AttributeComponent },
  { path: 'attributeList', component: AttributeListComponent },
  
  { path: 'category', component: CategoryComponent },
  { path: 'entity', component: EntityComponent },
  { path: 'subcategory', component: SubcategoryComponent },
  { path: 'user', component: UserComponent },
  { path: 'analytics', component: AnalyticsComponent },
  { path: 'Dashboard', component: PagenotfoundComponent },
    { path: 'ApiGroupForm', component: ApiGroupComponent },
  { path: 'ApiGroup', component: ApigrouplistComponent },
  { path: 'repository', component: RepositoryComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {


}
